import React from 'react';
import { ModulePlaceholder } from 'src/screens/Private/ModulePlaceholder';
import { homeMenu } from './home';
import { MenuItem } from '../../../commons/ui/menu';
import { promotionOperationMenu } from './PromotionOperation';
import { publicationsMenu } from './Publications';

const createPendingModuleMenu = (key: string, basePath: string, title: string): MenuItem => ({
  key,
  basePath,
  enabled: true,
  icon: 'List',
  text: title,
  children: [
    {
      key: `${key}Main`,
      basePath: '/',
      target: {
        component: () => React.createElement(ModulePlaceholder, { title }),
        path: '/',
      },
      enabled: true,
      icon: 'List',
      text: title,
      children: [],
      default: true,
    },
  ],
});

export const routes: MenuItem[] = [
  homeMenu,
  promotionOperationMenu,
  publicationsMenu,
  createPendingModuleMenu('commercialManagement', '/commercial-management', 'Gestión Comercial'),
  createPendingModuleMenu('operations', '/operations', 'Operaciones'),
  createPendingModuleMenu('configuration', '/configuration', 'Configuración'),
  createPendingModuleMenu('visualContent', '/visual-content', 'Contenido Visual'),
];
